module.exports = __webpack_public_path__ + "img/bb.3fb12ea5.svg";